import { Menu, Dropdown, Button, DropDownProps, Tooltip } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { useCallback, useMemo } from 'react';
import { useSlateStatic } from 'slate-react';
import LyEditor from '../utils/LyEditor';
import { useConceptText } from '../renders/TagConcept';
import { What } from 'views/Marketing/components/PolicyTable';
import { useTranslate } from '@tolgee/react';

export interface Concept {
  id: Marketing.Concept | Todo.Concept;
  label: string;
  showTips?: boolean;
}

interface Props extends Omit<DropDownProps, 'overlay'> {
  concepts: Concept[];
}

const ConceptMenu = (props: Props) => {
  const { concepts, ...otherProps } = props;

  const { t } = useTranslate();

  const { getConceptText, conceptTipsLabel } = useConceptText();

  const editor = useSlateStatic();

  const handleMenuClick = useCallback(
    ({ key }) => {
      LyEditor.insertConcept(editor, key);
    },
    [editor],
  );

  const menu = useMemo(() => {
    if (concepts.length) {
      return (
        <Menu onClick={handleMenuClick}>
          {concepts.map(({ id, label, showTips = true }) => (
            <Menu.Item key={id}>
              <Button size="small" type="link">
                {getConceptText(label)}
                {conceptTipsLabel[id] && showTips && (
                  <Tooltip title={conceptTipsLabel[id]}>
                    <What />
                  </Tooltip>
                )}
              </Button>
            </Menu.Item>
          ))}
        </Menu>
      );
    }
    return null;
  }, [concepts, conceptTipsLabel, handleMenuClick, getConceptText]);

  return menu ? (
    <Dropdown overlay={menu} {...otherProps}>
      <Button type="link">
        {t('insert_variables')} <DownOutlined />
      </Button>
    </Dropdown>
  ) : null;
};

export default ConceptMenu;
